import $ from 'jquery';

var siteUrl = window.ajax_questions_params.ajax_url;
var siteNonce = window.ajax_questions_params.nonce;

var currentFilters = [];

function fetchQuestions(page, filterTermIds = []) {
    var data = {
        action: 'fetch_questions',
        page: page,
        nonce: siteNonce,
    };

    if (filterTermIds.length > 0) {
        data.filter_term_ids = filterTermIds;
    }

    $.ajax({
        url: siteUrl,
        type: 'POST',
        data: data,
        success: function(response) {
            var decodedQuestions = $('<textarea/>').html(response.questions).text();
            var decodedPagination = $('<textarea/>').html(response.pagination).text();
            $('.questions-accordion, #questions-pagination').fadeOut(150, function() {
                $('.questions-accordion').html(decodedQuestions);
                $('#questions-pagination').html(decodedPagination);

                $('.questions-accordion, #questions-pagination').fadeIn(150);
            });

            $('.filter-count__number').html(response.count ? response.count : 0).text();

            if (response.count === 1) {
                $('.filter-count__suffix').text("fråga");
            } else {
                $('.filter-count__suffix').text("frågor");
            }


            if (filterTermIds.length > 0) {
                $('.filter-reset').addClass("visible");
            } else {
                $('.filter-reset').removeClass("visible");
            }
        },
    });
}

$(document).on('click', '.questions-pagination a', function(e) {
    e.preventDefault();

    var href = $(this).attr('href');
    var page;

    if (href.includes('/page/')) {
        var parts = href.split('/page/');
        page = parts[1];
    } else {
        page = 1;
    }

    fetchQuestions(page, currentFilters);
});

$('.update-filter').click(function() {
    const selectedFilters = Array.from(document.querySelectorAll('.questions-filter input[type="checkbox"]:checked')).map(input => input.value);
    currentFilters = selectedFilters;

    $('.questions-filter-container').stop().slideToggle(200);
    $('.questions-filter-container').toggleClass("filter-open");

    fetchQuestions(1, selectedFilters);
});

$('.filter-reset').click(function() {
    fetchQuestions(1, []);

    $('.questions-filter input[type="checkbox"]:checked').prop('checked', false).prop('disabled', false);
});


// WEBPACK FOOTER //
// ./scripts/ajax-questions.js